// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"d8e4cc99","443":"0d26c672","630":"61bf20e2","989":"a2923dc7"}[chunkId] + ".chunk.css";
};